@if (showOcrButton) {
  <button
    type="button"
    class="btn btn-sm mt-1"
    [ngClass]="{ 'btn-warning': !ocrDone, 'btn-success': ocrDone }"
    [disabled]="annotationsRunning"
    (click)="onOcrBackfillClick($event)"
    [ngbTooltip]="toolTip"
    placement="bottom"
    >
    <mat-spinner diameter="16" class="mat-spinner" [hidden]="!annotationsRunning" />
    <fa-icon [hidden]="annotationsRunning" [icon]="['fas', 'server']" />
    <span>Check Consult Note</span>
  </button>
} @else if (showLlmButton) {
  <button
    type="button"
    class="btn btn-sm mt-1"
    [ngClass]="{ 'btn-warning': !llmSuccess, 'btn-success': llmSuccess }"
    [disabled]="llmRunning"
    (click)="onLlmRerunClick($event)"
    placement="bottom"
    >
    <mat-spinner diameter="16" class="mat-spinner" [hidden]="!llmRunning" />
    <fa-icon [hidden]="llmRunning" [icon]="['fas', 'server']" />
    <span>Rerun LLM Prompts</span>
  </button>
}
